import React, { FC } from 'react';

import { TextElementT } from './types';
import { TextElement as Atom } from '@components/Atoms';

export const TextElement: FC<TextElementT> = ({ display = true, text }) => {
  return display ? <Atom text={text} /> : null;
};
